import {apiGetFactorSummary} from "api/reportApi";

import {AmountComponent, PriceComponent} from "components/Table/CellComponents";

const factorSummaryColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        size: "2",
        disableSearch: true,
    },
    {
        name: "نام نمایشی",
        key: "person",
        size: "7",
        navigateKey: (item: any) => item.personId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
        disableSearch: true,
    },
    {
        name: "تعداد",
        key: "count",
        Component: AmountComponent,
        size: "4",
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "مجموع مبلغ کالا",
        key: "totalPrice",
        Component: PriceComponent,
        size: "5",
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "تخفیف",
        key: "discount",
        Component: PriceComponent,
        size: "4",
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "سود",
        key: "profit",
        Component: PriceComponent,
        size: "4",
        searchType: "quantitative",
        disableSearch: true,
    },
];

export const factorSummaryIndexData = [
    {
        key: "factorSummary",
        label: "خلاصه فاکتور به تفکیک شخص",
        pluralLabel: "خلاصه فاکتور به تفکیک شخص",
        title: "خلاصه فاکتور به تفکیک شخص",
        pageTitle: "خلاصه فاکتور به تفکیک شخص",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: factorSummaryColumns,
        disableSearch: true,
        actions: {
            back: {},
            fetch: apiGetFactorSummary,
            // excel: {},
        },
    },
];
